import React from 'react'

function Addclient() {
  return (
    <div>
      <h2>Hello</h2>
    </div>
  )
}
export default Addclient;